import { useContext } from "react";
import { SiteSettingsContext } from "./site-settings-context";

export function useGetSiteSettings() {
	const settings = useContext(SiteSettingsContext);
	if (!settings) {
		throw new Error(
			"useGetSiteSettings must be used within a SiteSettingsProvider",
		);
	}
	return settings.properties;
}
